<sub-nav-options class="ml-11px mt-10px mb-10px d-block" [options]="options"></sub-nav-options>
<div class="borderline"></div>
<nav-items-list
  *ngIf="(loadingCustomViews$ | async) === false && customViews && customViews.items.length"
  [collection]="customViews"
  [config]="{
    sectionLabelKey: 'custom views',
    visibleItemsCount: 5,
    itemsGroupType: 'taskgroups',
    itemsType: 'tasks',
    broadcastConfig
  }"></nav-items-list>
<tasks-empty-sub-nav *ngIf="(loadingCustomViews$ | async) === false && customViews && !customViews.items.length"></tasks-empty-sub-nav>
